import checkout from "./form";

const {
  formField: {
    fullName,
    chiefAccountant,
    accountingServices,
    signer,
    certificate,
    timeSign,

    taxpayersName,
    taxpayersId,

    htldl,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [certificate.name]: "",
  [timeSign.name]: "",
  [chiefAccountant.name]: "",
  [accountingServices.name]: "",

  [taxpayersName.name]: "",
  [taxpayersId.name]: "",

  [htldl.name]: false,
};

export default initialValues;
